import { createContext, useContext, useEffect, useMemo, type ReactNode } from 'react';
import { useQuery } from '@tanstack/react-query';
import { patientPortal } from '@/api/patientPortal';
import {
  DEFAULT_PATIENT_PORTAL_BRANDING,
  mergePortalBranding,
  type PatientPortalBranding,
} from './patientPortalBranding';

const BrandingContext = createContext<PatientPortalBranding>(DEFAULT_PATIENT_PORTAL_BRANDING);

export function PatientPortalBrandingProvider({ children }: { children: ReactNode }) {
  const { data } = useQuery({
    queryKey: ['patient-portal-branding'],
    queryFn: () => patientPortal.getBranding(),
    staleTime: 5 * 60 * 1000,
    retry: 1,
  });

  const branding = useMemo(() => mergePortalBranding(data ?? null), [data]);

  useEffect(() => {
    document.title = branding.hospitalName?.trim() || 'Patient portal';
  }, [branding.hospitalName]);

  return <BrandingContext.Provider value={branding}>{children}</BrandingContext.Provider>;
}

export function usePatientPortalBranding() {
  return useContext(BrandingContext);
}
